import {Modal, Radio, Tag} from 'antd';
import {useState} from 'react';

import {useLocale} from '../../../../../../../provider/locale/locale-hook';
import {Locale} from '../../../../../../../provider/locale/localization';

import {addressCommentTemplateList, addressCommentTemplatesModalWidth} from './address-comment-templates-const';
import {getAddressCommentSegmentList} from './address-comment-templates-helper';
import {
    AddressCommentSegmentKindEnum,
    AddressCommentTemplateIdEnum,
    AddressCommentTemplateType,
} from './address-comment-templates-type';
import * as styles from './address-comment-templates.scss';

type PropsType = {
    onApply: (template: AddressCommentTemplateType) => void;
    onClose: () => void;
};

export function AddressCommentTemplatesModal(props: PropsType): JSX.Element {
    const {onApply, onClose} = props;

    const {getLocalizedString} = useLocale();
    const [selectedTemplateId, setSelectedTemplateId] = useState<AddressCommentTemplateIdEnum | null>(null);

    const selectedTemplate = addressCommentTemplateList.find(({id}) => id === selectedTemplateId) ?? null;

    return (
        <Modal
            centered
            destroyOnClose
            maskClosable
            okButtonProps={{disabled: !selectedTemplate}}
            okText={<Locale stringKey="TEXT__APPLY" />}
            onCancel={onClose}
            onOk={() => {
                if (selectedTemplate) {
                    onApply(selectedTemplate);
                }
            }}
            open
            title={<Locale stringKey="COMPANY_FORM__ADDRESS__COMMENT__TEMPLATES__MODAL_TITLE" />}
            width={addressCommentTemplatesModalWidth}
        >
            <Radio.Group
                className={styles.AddressCommentTemplates_optionList}
                onChange={(event) => setSelectedTemplateId(event.target.value)}
                value={selectedTemplateId}
            >
                {addressCommentTemplateList.map((template) => (
                    <Radio className={styles.AddressCommentTemplates_option} key={template.id} value={template.id}>
                        {getAddressCommentSegmentList(template, getLocalizedString).map((segment, index) =>
                            segment.kind === AddressCommentSegmentKindEnum.text ? (
                                // eslint-disable-next-line react/no-array-index-key
                                <span key={index}>{segment.text}</span>
                            ) : (
                                <Tag className={styles.AddressCommentTemplates_optionTag} key={segment.field.name}>
                                    {getLocalizedString(segment.field.hintKey)}
                                </Tag>
                            )
                        )}
                    </Radio>
                ))}
            </Radio.Group>
        </Modal>
    );
}
